// extracted by mini-css-extract-plugin
export default {"modalContainer":"GlobalMessagePopup_modalContainer__NtdmB","message":"GlobalMessagePopup_message__j1Tq1","buttonContainer":"GlobalMessagePopup_buttonContainer__rfj2u"};